import { render, staticRenderFns } from "./text-header.vue?vue&type=template&id=7eb549b5&scoped=true"
import script from "./text-header.vue?vue&type=script&lang=js"
export * from "./text-header.vue?vue&type=script&lang=js"
import style0 from "./text-header.vue?vue&type=style&index=0&id=7eb549b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb549b5",
  null
  
)

export default component.exports